'use strict';
const utils = require('../utils/utils');

function isAnonymous() {
  return typeof utils.queryCookie('wixClient') === 'undefined';
}

function language() {

  const subDomain = location.host.split('.')[0];
  if (subDomain !== 'www' && subDomain.length === 2) {
    return subDomain;
  }

  const lang = utils.queryCookie('wixLanguage');
  if (typeof lang !== 'undefined') {
    return lang;
  }

  const wixMenu = document.getElementById('wix-menu');
  if (wixMenu !== null && typeof wixMenu.getAttribute('lang') !== 'undefined') {
    return wixMenu.getAttribute('lang');
  }
  return 'en';
}

function setToLocalStorage(key, value) {
  localStorage.setItem(key, value);
}

function sawNotification() {
  if (localStorage) {
    const key = localStorage.getItem('wixCookieNotification');
    return typeof key !== 'undefined' && key === 'approved';
  } else {
    return false;
  }
}

export {sawNotification, setToLocalStorage, language, isAnonymous};



// WEBPACK FOOTER //
// ./modules/userDetails.js